import { render } from "./DetailMetricChart.vue?vue&type=template&id=fa24569a"
import script from "./DetailMetricChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailMetricChart.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/containers/components/metric/DetailMetricChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fa24569a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fa24569a', __exports__)) {
    api.reload('fa24569a', __exports__)
  }
  
  module.hot.accept("./DetailMetricChart.vue?vue&type=template&id=fa24569a", () => {
    api.rerender('fa24569a', render)
  })

}


export default __exports__